import React from 'react'

export default function Products() {
  return (
    <section className='section'>
      <div className='container-fluid'>
        <h1 className='main-title text-center'>My New Title</h1>
        <h4 className='sub-title text-center'>My New Title</h4>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        <div className='info-list'>
          <ul>
            <li>Automobile ancillery</li>
            <li>Textile machinery</li>
            <li>Defence</li>
            <li>Pharma machinery</li>
            <li>Food processing ind</li>
            <li>Ceramic industries</li>
            <li>Printing and paper industries</li>
            <li>Dia & Mold</li>
            <li>Bearings industries</li>
          </ul>
        </div>
      </div>
    </section>
  )
}
